var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":_vm.schema.defaultActive}},_vm._l((_vm.schema.items),function(item){return _c('menu-bar-item',{key:item.id,attrs:{"schema":item,"roles":_vm.roles}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }